import { Route, Routes, Navigate } from 'react-router-dom';
import Home from '../common/components/home/home';
import ArchiveMail from '../Outlook/archiveMail/archiveMail';
import ArchiveMultipleMail from '../Outlook/archiveMail/archiveMultipleMail';
import ArchiveFile from '../Office/archiveFile/archiveFile';
import QuickSave from '../Outlook/QuickSave/QuickSave';
import { AccessReviewPage } from '../Outlook/QuickSave/AccessReview';
import { ImportArchivePage } from '../Outlook/QuickSave/ImportArchive';

export const routes = (
    <Routes >
        <Route path='/' element={<Home />} />
        <Route path='/archivehome' element={<Home />} />
        <Route path='/archiveMail' element={<ArchiveMail />} />
        <Route path='/archiveMultipleMail' element={<ArchiveMultipleMail />} />
        <Route path='/archiveFile' element={<ArchiveFile />} />
        <Route path='/quicksave' element={<QuickSave />} />
        <Route path='/accessReview' element={<AccessReviewPage />} />
        <Route path='/importArchive' element={<ImportArchivePage />} />
        <Route path="*" element={<Navigate to="/" />} />
    </Routes >
);